import { render, staticRenderFns } from "./tab-cell-status.vue?vue&type=template&id=bb0bf636&scoped=true"
import script from "./tab-cell-status.vue?vue&type=script&lang=js"
export * from "./tab-cell-status.vue?vue&type=script&lang=js"
import style0 from "./tab-cell-status.vue?vue&type=style&index=0&id=bb0bf636&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0bf636",
  null
  
)

export default component.exports